import { Patient } from '@/types/patient';

export enum ReservationStatus {
  PENDING = 'PENDING',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  NO_SHOW = 'NO_SHOW',
}

export type Reservation = {
  id: number;
  patient: Patient;
  status: ReservationStatus;
  slot: string;
  completed_at: string;
};
